import axios from 'axios';
import { greetOrName, renderMessage, sharePdfToWhatsApp, waUrl } from './waShare';
import { API } from './api';
import { fmtINR } from '../components/admin/billing/shared';

export const niceDate = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString('en-IN', { weekday: 'short', day: '2-digit', month: 'short' }) : '');
export const niceSlot = (w) => (w || '').replace(/:00-/, '–').replace(/:00$/, '');

export const pickupText = (p) => (p?.required ? [p.time, p.address].filter(Boolean).join(' from ') || 'Yes, we will call to arrange' : '');
export const packagesText = (row) => {
  const pk = row.packages || [];
  if (!pk.length) return '';
  const total = pk.reduce((s, p) => s + Number(p.price || 0), 0);
  return `${pk.map((p) => p.name).join(', ')}${total > 0 ? ` · ₹ ${fmtINR(total)}` : ''}`;
};

// One builder for every appointment WhatsApp message.
const aptMessage = (row, key) => {
  const c = row.customer || {}; const v = row.vehicle || {};
  const adv = Number(row.advance_amount || 0);
  return renderMessage(key, {
    customer: greetOrName(c.prefix, c.name), ref: row.ref_no || '', service: row.service_type || '',
    vehicle: [v.year, v.make, v.model].filter(Boolean).join(' ') || v.registration_number || 'your vehicle',
    slot: `${niceDate(row.slot_date)} · ${niceSlot(row.slot_window)}`,
    advance: adv > 0 ? adv.toLocaleString('en-IN') : '',
    advance_status: row.advance_paid_status === 'paid' ? '(received)' : '(pending)',
    advance_due: adv > 0 && row.advance_paid_status !== 'paid' ? adv.toLocaleString('en-IN') : '',
    packages: packagesText(row), pickup: pickupText(row.pickup),
  });
};

const aptPhone = (row) => String(row.customer?.phone || '').replace(/[^\d]/g, '');

export const aptWaUrl = (row, key) => (aptPhone(row) ? waUrl(aptPhone(row), aptMessage(row, key)) : '');

const CARD_TEMPLATES = { confirm: 'appointment_confirm', reminder_24h: 'appointment_reminder_24h', reminder_2h: 'appointment_reminder_2h' };

// Branded card (PNG from the server) + the matching message: confirm or reminder.
export const shareAptCard = (row, authHeader, variant = 'confirm') => sharePdfToWhatsApp({
  getPdf: () => axios.get(`${API}/appointments/${row.id}/card`, { params: { variant }, headers: authHeader(), responseType: 'blob' }).then((r) => r.data),
  filename: `${(row.ref_no || 'booking').replace(/[^A-Za-z0-9]+/g, '-')}${variant === 'confirm' ? '' : '-reminder'}.png`,
  title: `${variant === 'confirm' ? 'Booking' : 'Reminder'} ${row.ref_no || ''}`.trim(),
  message: aptMessage(row, CARD_TEMPLATES[variant]),
  phone: aptPhone(row),
  type: 'image/png',
  kind: 'Card',
});
